import { Pipe, PipeTransform } from '@angular/core';
/**
 * Transform the State of the ServiceFilterModule based on the Type
 */
@Pipe({
  name: 'translateFilterServiceModule'
})
export class TranslateFilterServiceModulePipe implements PipeTransform {
/**
 * Transform the state based on the Type
 * @param value 
 * @returns 
 */
  transform(value: string[]): string[] {
    let returnArray = [];
    value.forEach((element, index) => {
      switch (element) {
        case 'event':
          if (returnArray.length == 0) {
            returnArray.push("Aktionswelt");
          }
          break;
        case 'news':
          if (returnArray.length == 0) {
            returnArray.push("Infothek");
          }
          break;
        case 'card':
          if (returnArray.length == 0) {
            returnArray.push("Karte");
          }
          break;
        default:
          returnArray.push(element);
          break;
      }
    });
    return returnArray

  }
}
